import { useSignupState } from './useSignupState'

export const useTheme = () => useSignupState().theme
